export const LOADER_STATUS = 'boilerplate/NewEinv/FailedInvoice/LOADER_STATUS';
export const TABLE_DATA = 'boilerplate/NewEinv/FailedInvoice/TABLE_DATA';
export const SAVE_TOTAL_PAGES = 'boilerplate/NewEinv/FailedInvoice/SAVE_TOTAL_PAGES';
export const TOTAL_RECORDS = 'boilerplate/NewEinv/FailedInvoice/TOTAL_RECORDS';
export const ITEM_ERROR_DATA = 'boilerplate/NewEinv/FailedInvoice/ITEM_ERROR_DATA';
export const TXN_ERROR_DATA = 'boilerplate/NewEinv/FailedInvoice/TXN_ERROR_DATA';
export const ITEM_LIST_DATA = 'boilerplate/NewEinv/FailedInvoice/ITEM_LIST_DATA';